export enum HybridTypeEnum {
  HYBRIDTYPE_FULL = 'HYBRIDTYPE_FULL',
  HYBRIDTYPE_PHEV = 'HYBRIDTYPE_PHEV',
  HYBRIDTYPE_MHEV = 'HYBRIDTYPE_MHEV',
  HYBRIDTYPE_MICRO = 'HYBRIDTYPE_MICRO',
}
